module.exports = __webpack_public_path__ + "87a3c275f908d4f7edf0167265529cc9.png";